import styled from 'styled-components';
import { Flex } from 'antd';

export const AuthWrapper = styled(Flex)`
  min-height: var(--viewport-height);
  height: var(--viewport-height);
  background: url('../../../assets/icons/login-bg.png') no-repeat;
  background-size: cover;

  .login-container {
    padding: 40px 20px;
    width: 100%;
    text-align: center;
    height: 100%;
  }

  .content-wrapper {
    max-width: 328px;
    width: 100%;
    margin: 0 auto;
    flex-grow: 1;
    position: relative;
    z-index: 0;
  }

  .content-wrapper .app-logo {
    margin: 0 auto;
  }

  .content-wrapper p {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: var(--clr-white);
  }

  .content-wrapper h6 {
    font-size: 20px;
    font-weight: 600;
    color: var(--clr-white);
  }

  /* .content-wrapper::after {
    content: '';
    filter: blur(125px);
    position: absolute;
    z-index: -1;
    opacity: 0.3;
    width: 100%;
    min-width: 465px;
    height: 100%;
    background: radial-gradient(101.33% 227.09% at 8.8% 55.69%, #5956e9 0%, #dcc078 57.81%);
    transform: rotate(90deg);
  } */
`;
